import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlbums: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"albums, cover"} maskId="square-filled-radius-0-stroke-1-IconAlbums"><path fillRule="evenodd" clipRule="evenodd" d="M11 2.87646L21 5.09869V18.9009L11 21.1231V2.87646ZM8 3.99977V19.9998H7V3.99977H8ZM4 4.99977V18.9998H3V4.99977H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAlbums;
